import { useTranslation } from 'react-i18next'
import { TextLink } from '@/components/TextLink/TextLink'
import { useInboundSalesOpen } from '@/utils/useInboundSalesOpen'
import { Text } from 'ui/src/components/Text/Text'
import { PhoneIcon } from 'ui/src/icons/PhoneIcon'
import { xStack } from 'ui/src/patterns/stack'
import { tokens } from 'ui/src/theme/tokens.css'
import { card } from './InboundSalesCard.css'

export function InboundSalesCard() {
  const { t } = useTranslation('purchase-form')
  const { isOpen, phone } = useInboundSalesOpen()

  if (!isOpen || !phone) {
    return null
  }

  return (
    <div className={card}>
      <PhoneIcon style={{ flexShrink: 0 }} size="1.5rem" color={tokens.colors.signal.blue.element} />
      <div className={xStack({ flexGrow: 1, gap: 'sm', justifyContent: 'space-between' })}>
        <Text size="xs" color="textSecondary">
          {t('INBOUND_SALES_CARD_TITLE')}
        </Text>
        <TextLink href={`tel:${phone}`} size="xs" color="textSecondary" as="span">
          {phone}
        </TextLink>
      </div>
    </div>
  )
}
